import {
  DocumentGenerationTemplate,
  useDocumentGeneration_GenerateDocumentForPreviewMutation,
} from 'queries';

import Modal from 'common/modal';
import { NotificationSeverity, showAlert, showToast } from 'utils/notification-manager';

import DocumentGenerationTemplateForm from './document-generation-template-form';

type Props = {
  selectedDocumentGenerationTemplate: DocumentGenerationTemplate;
  setSelectedDocumentGenerationTemplate: (value: DocumentGenerationTemplate | undefined) => void;
  setShowModal: (value: boolean) => void;
  showModal: boolean;
};

export default function EditDocumentGenerationTemplateModal({
  selectedDocumentGenerationTemplate,
  setSelectedDocumentGenerationTemplate,
  setShowModal,
  showModal,
}: Props) {
  const onExitClick = () => {
    setShowModal(false);
    setSelectedDocumentGenerationTemplate(undefined);
  };

  const [generateDocumentForPreview, { loading: generateDocumentForPreviewExecuting }] =
    useDocumentGeneration_GenerateDocumentForPreviewMutation({
      onCompleted: ({ data }) => {
        try {
          const link = document.createElement('a');
          link.href = `data:${data.mimeType};base64,${data.contentBase64}`;
          link.download = data.fileName;
          link.click();

          showToast({
            message: 'Document preview generated successfully!',
            severity: NotificationSeverity.SUCCESS,
          });
        } catch (error) {
          showAlert({
            message: 'Error downloading CSV',
            severity: NotificationSeverity.ERROR,
          });
        }
      },
      onError: (e) => {
        showAlert({
          message: 'Error generating document preview: ' + e.message,
          severity: NotificationSeverity.ERROR,
        });
      },
    });

  const onDownloadPreview = async () => {
    generateDocumentForPreview({
      variables: {
        input: {
          documentGenerationTemplateId: selectedDocumentGenerationTemplate.id,
        },
      },
    });
  };

  return (
    <Modal
      overrideDialogContentStyles={{ overflow: 'unset' }}
      setShowModal={setShowModal}
      onExitClick={onExitClick}
      showModal={showModal}
      showActions={false}
      content={
        <DocumentGenerationTemplateForm
          isEditing={true}
          selectedDocumentGenerationTemplate={selectedDocumentGenerationTemplate}
          onDownloadPreview={onDownloadPreview}
          isSaveDisabled={generateDocumentForPreviewExecuting}
          onExitClick={onExitClick}
        />
      }
      loading={false}
      actionDisabled={false}
      maxWidth="xl"
    />
  );
}
